import { useState } from "react";
import { Download, MoreHorizontal, Eye, RefreshCw, Filter } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Button,
  DataTable,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  FiltersBar,
  transactionFilters,
  transactionTableConfig,
  mockTransactions,
} from "@b2b/ui-components";

const AdminTransactions = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Map transactions into DataTable rows
  const tableData = mockTransactions
    .filter(
      (txn) =>
        txn.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        txn.buyer.toLowerCase().includes(searchTerm.toLowerCase()) ||
        txn.seller.toLowerCase().includes(searchTerm.toLowerCase()) ||
        txn.product.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .map((txn) => {
      const statusStyle = transactionTableConfig.styles?.statusStyles?.[
        txn.status
      ] || {
        background: "bg-gray-100",
        textColor: "text-gray-700",
      };

      return {
        id: <div className="font-mono text-sm">{txn.id}</div>,
        buyer: <div className="font-medium">{txn.buyer}</div>,
        seller: <div className="font-medium">{txn.seller}</div>,
        product: <div className="max-w-xs truncate">{txn.product}</div>,
        amount: <div className="font-bold text-foreground">{txn.amount}</div>,
        status: (
          <span
            className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${statusStyle.background} ${statusStyle.textColor}`}
          >
            {txn.status}
          </span>
        ),
        paymentMethod: txn.paymentMethod,
        date: txn.date,
        actions: (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm">
                <MoreHorizontal className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-white">
              <DropdownMenuItem>
                <Eye className="mr-2 h-4 w-4" />
                View Details
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Download className="mr-2 h-4 w-4" />
                Download Invoice
              </DropdownMenuItem>
              {txn.status === "completed" && (
                <DropdownMenuItem>
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Process Refund
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        ),
      };
    });

  return (
    <div className="space-y-8 mt-5">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Transactions</h1>
          <p className="text-muted-foreground">
            Monitor payments, payouts, and transaction history
          </p>
        </div>
        <Button variant="primary">
          <Download className="mr-2 h-4 w-4" />
          Export Report
        </Button>
      </div>

      {/* Stats Cards */}
      <div className="grid gap-6 md:grid-cols-4">
        <Card>
          <CardContent className="p-6">
            <div className="space-y-2">
              <p className="text-sm font-medium text-muted-foreground">
                Total Volume
              </p>
              <p className="text-3xl font-bold text-foreground">$2.4M</p>
              <p className="text-sm text-green-600">+15% from last month</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <div className="space-y-2">
              <p className="text-sm font-medium text-muted-foreground">
                Completed
              </p>
              <p className="text-3xl font-bold text-foreground">8,457</p>
              <p className="text-sm  text-green-600">+12% from last month</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <div className="space-y-2">
              <p className="text-sm font-medium text-muted-foreground">
                Pending
              </p>
              <p className="text-3xl font-bold text-foreground">247</p>
              <p className="text-sm text-orange-300">+8% from last month</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <div className="space-y-2">
              <p className="text-sm font-medium text-muted-foreground">
                Commission
              </p>
              <p className="text-3xl font-bold text-foreground">$72K</p>
              <p className="text-sm text-green-600">+18% from last month</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Filters */}
      <FiltersBar filters={transactionFilters} showSearch card />

      {/* Transactions Table */}
      <Card>
        <CardHeader>
          <CardTitle>Transaction History</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            data={tableData}
            config={transactionTableConfig}
            rowsPerPage={5}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminTransactions;
